"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const store_1 = require("store");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const planning_action_1 = __importDefault(require("./planning.action"));
const authorization_1 = require("utils/authorization");
const header_menu_1 = __importDefault(require("components/molecules/header-menu"));
const tab_1 = __importDefault(require("components/molecules/tabs/tab"));
const modal_1 = require("components/molecules/modal");
// Tabs Components
const production_1 = __importDefault(require("./production"));
const transhipment_1 = __importDefault(require("./transhipment"));
const hauling_1 = __importDefault(require("./hauling"));
const AdjustmentPlanning = () => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { isError, isSuccess, isLoading, errorMessage } = (0, store_1.useAppSelector)(state => state.adjustment.planning);
    const { appTheme } = (0, store_1.useAppSelector)(state => state.app);
    const { userData } = (0, store_1.useAppSelector)(state => state.auth);
    const isAuthorized = (0, authorization_1.userRoleAuth)(userData.authorization, 'Adjustment', 'Planning');
    (0, react_1.useEffect)(() => {
        if (!isAuthorized.view || !isAuthorized.change) {
            navigate('/dashboard', { replace: true });
        }
    }, [isAuthorized]);
    const planningTabs = [
        { index: 0, labels: 'Production' },
        { index: 1, labels: 'Hauling' },
        { index: 2, labels: 'Barge Loading & Transshipment' }
    ];
    const [tabsMode, setTabsMode] = (0, react_1.useState)('Production');
    const onChangeTab = (mode) => {
        setTabsMode(mode);
        dispatch(planning_action_1.default.onClickMutation({ mutationMode: false, isLoading: true }));
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(header_menu_1.default, { theme: appTheme, title: 'Planning', isLoading: isLoading }), (0, jsx_runtime_1.jsx)(tab_1.default, { tabs: planningTabs, onChangeTab: onChangeTab }), tabsMode === 'Production' ? (0, jsx_runtime_1.jsx)(production_1.default, {}) :
                tabsMode === 'Hauling' ? (0, jsx_runtime_1.jsx)(hauling_1.default, {}) : (0, jsx_runtime_1.jsx)(transhipment_1.default, {}), (0, jsx_runtime_1.jsx)(modal_1.ModalSuccess, { show: isSuccess, appTheme: appTheme, messageSuccess: 'Data Saved Successfully', onClose: () => {
                    dispatch(planning_action_1.default.onClickMutation({ mutationMode: false, isSuccess: false, isLoading: false }));
                } }), (0, jsx_runtime_1.jsx)(modal_1.ModalError, { show: isError, appTheme: appTheme, style: { 'zIndex': 10 }, errorMessage: errorMessage, onClose: () => dispatch(planning_action_1.default.onCloseError()) })] }));
};
exports.default = AdjustmentPlanning;
